/** Parse Word Connect pool bulk text (comma or newline separated words). */
export function parseWordConnectBulkText(raw: string): string[] {
  const out: string[] = [];
  const seen = new Set<string>();

  for (const chunk of raw.split(/[\n,;]+/)) {
    const normalized = chunk
      .trim()
      .toUpperCase()
      .replace(/[^A-ZÁÀÂÃÉÊÍÓÔÕÚÜÇ]/g, '');
    if (normalized.length < 2 || seen.has(normalized)) continue;
    seen.add(normalized);
    out.push(normalized);
  }

  return out;
}
